<div style="position: relative;">
    <button mat-icon-button style="position: absolute;right: -10px;top: -20px;z-index: 999;" (click)="closeDialog()">
        <mat-icon>close</mat-icon>
    </button>
    <mat-dialog-content>
        <app-cert-wiz-controller *ngIf="config?.key=='CertWizControllerComponent'" 
            [isDialog]="true"
            [isApp]="config?.data?.isApp" 
            [addWizObj]="config?.data?.addWizObj"
        ></app-cert-wiz-controller>
        <app-app-wizard-header *ngIf="config?.key=='AppWizardHeaderComponent'" 
            [isDialog]="true"
            [isApp]="config?.data?.isApp" 
            [addWizObj]="config?.data?.addWizObj"
            [personalInfo]="config?.data?.personalInfo"
        ></app-app-wizard-header>
    </mat-dialog-content>
</div>